import TextField from "@mui/material/TextField";
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

const AccountInformation = ({data, account,  onFieldChange}) => {

    return (
        
        <div className="panel">
            { account !== undefined && data !== undefined &&
            <div>
            <div>
                <TextField
                    fullWidth
                    required
                    id="username" 
                    label="Username" 
                    variant="outlined"
                    className="TextField"
                    value={data.username}
                    size="small"
                    onChange={(event, value) => onFieldChange(event, event.target.value, event.target.id)}
                    InputLabelProps={{
                        shrink: true,
                        }}
                />
            </div>
            <div>
                <TextField
                    fullWidth
                    required
                    id="email" 
                    label="Email Address" 
                    variant="outlined"
                    className="TextField"
                    type="email"
                    value={data.email}
                    size="small"
                    onChange={(event, value) => onFieldChange(event, event.target.value, event.target.id)}
                    InputLabelProps={{
                        shrink: true,
                        }}
                />
            </div>
            <div>
                <TextField
                    fullWidth
                    id="name" 
                    label="Name" 
                    variant="outlined"
                    className="TextField"
                    value={data.name}
                    size="small"
                    onChange={(event, value) => onFieldChange(event, event.target.value, event.target.id)}
                    InputLabelProps={{
                        shrink: true,
                        }}
                />
            </div>
            <div>
                <TextField
                    fullWidth
                    id="middleName" 
                    label="MiddleName" 
                    variant="outlined"
                    className="TextField"
                    value={data.middleName}
                    size="small"
                    onChange={(event, value) => onFieldChange(event, event.target.value, event.target.id)}
                    InputLabelProps={{
                        shrink: true,
                        }}
                />
            </div>
            <div>
                <TextField
                    fullWidth
                    id="surname" 
                    label="Surname" 
                    variant="outlined"
                    className="TextField"
                    value={data.surname}
                    size="small"
                    onChange={(event, value) => onFieldChange(event, event.target.value, event.target.id)}
                    InputLabelProps={{
                        shrink: true,
                        }}
                />
            </div>
         
            <FormGroup>
               <div id="FormGroup">
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={data.isAdministrator}
                            id="isAdministrator" 
                            inputProps={{ 'aria-label': 'IsAdministrator' }}
                            onChange={(event, value) => onFieldChange(event, event.target.checked, event.target.id)}
                            InputLabelProps={{
                                shrink: true,
                                }}
                        />
                    }
                    label="IsAdministrator"
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={data.isOperator}
                            id="isOperator" 
                            onChange={(event, value) => onFieldChange(event, event.target.checked, event.target.id)}
                            inputProps={{ 'aria-label': 'IsOperator' }}
                            InputLabelProps={{
                                shrink: true,
                                }}
                        />
                    }
                    label="IsOperator"
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={data.isActive}
                            id="isActive" 
                            onChange={(event, value) => onFieldChange(event, event.target.checked, event.target.id)}
                            inputProps={{ 'aria-label': 'IsActive' }}
                            InputLabelProps={{
                                shrink: true,
                                }}
                     />
                    }
                    label="IsActive"
                />
            </div>
           </FormGroup>

            <div>
            <FormControl fullWidth style={{flexDirection: "row"}}>
                {/* <InputLabel>Password Policy Information</InputLabel> */}
                <TextField
                    fullWidth
                    id="lastLoggedIn" 
                    disabled = {true}
                    label="Last Logged In" 
                    variant="outlined"
                    className="TextField"
                    value={account.lastLoggedIn}
                    size="small"
                    onChange={(event, value) => onFieldChange(event, event.target.value, event.target.id)}
                    InputLabelProps={{
                        shrink: true,
                        }}
                />
                 <TextField style={{marginLeft: "10px"}}
                    fullWidth
                    id="nbOfFailedAttempts" 
                    disabled = {true}
                    label="Nb of Failed Attempts" 
                    variant="outlined"
                    className="TextField"
                    value={account.nbOfFailedAttempts}
                    size="small"
                    onChange={(event, value) => onFieldChange(event, event.target.value, event.target.id)}
                    InputLabelProps={{
                        shrink: true,
                        }}
                />
                 <TextField style={{marginLeft: "10px"}}
                    fullWidth
                    disabled = {true}
                    id="lastLoginAttempt" 
                    label="Last Login Attempt" 
                    variant="outlined"
                    className="TextField"
                    value={account.lastLoginAttempt}
                    size="small"
                    onChange={(event, value) => onFieldChange(event, event.target.value, event.target.id)}
                    InputLabelProps={{
                        shrink: true,
                        }}
                />
            </FormControl>
            </div>
        </div>
           
    }
     </div>  
                   
        
    )
}

export default AccountInformation;
